import React from "react";

import Modal from "../../Modal";
import CrossingEdit from "../edit";

import { connect } from "react-redux";
import { postCrossing, hideModal } from "../../../actions";

class EditModal extends React.Component {

    onClose = (e) => {
        e.preventDefault();
        // this.props.hideModal();

        // are you sure you want to close?
        // if yes, hide modal
        // if no, do nothing
        if (window.confirm("Are you sure you want to close?")) {
            this.props.hideModal();
        }

    }

    render() {
        if (!this.props.modal || !this.props.modal.visible || this.props.modal.modalType !== 'post') {
            return null;
        }
        
        return (
            <Modal
                title="What border did you cross?"
                content={<CrossingEdit />}
                onDismiss={this.onClose}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        modal: state.modal
    }
}

export default connect(mapStateToProps, { hideModal, postCrossing })(EditModal);